/* global document */
(function () {
  'use strict';

  function menuExcluirPontoReferenciaDirective() {
    return {
      templateUrl: 'directives/map-control/menu-map-control/menu-map-control.tpl.html',
      controller: 'MenuExcluirPontoReferenciaCtrl',
      controllerAs: 'ctrl',
      restrict: 'E'
    };
  }

  class MenuExcluirPontoReferenciaCtrl {
    constructor($scope, $rootScope, $uibModal, AlertMessage, PontosReferenciaTools, PontosReferenciaMap, PontosReferenciaMenu, PontosReferencia, $translate, CadastroRotogramaService) {
      this.rootScope = $rootScope;
      this.scope = $scope;
      this.modalService = $uibModal;
      this.alertMessage = AlertMessage;
      this.pontosReferenciaToolsService = PontosReferenciaTools;
      this.pontosReferenciaMapService = PontosReferenciaMap;
      this.pontosReferenciaMenuService = PontosReferenciaMenu;
      this.pontosReferenciaService = PontosReferencia;
      this.translate = $translate;
      this.cadastroRotogramaService = CadastroRotogramaService;
      this.init();
    }

    init() {
      let buttonsPrincipal = {
            active: 'fa fa-pencil-square-o',
            resting: 'fa fa-pencil-square-o'
          },
          buttons = [
              {
                titulo: 'ce.mapa.common.tituloBtExcluirPonto',
                icon: 'fa fa-check',
                color: 'success',
                tipo: 'default',
                funcao: this.excluirPontoBanco.bind(this)
              },
              {
                titulo: 'ce.mapa.common.tituloBtCancelar',
                icon: 'fa fa-times',
                color: 'danger',
                tipo: 'editar'
              }
          ];
      this.pontosReferenciaMenuService.setMenu(buttons, buttonsPrincipal);
      this.pontosReferenciaMenuService.drawerClose();
      this.pontosReferenciaMenuService.menuOpen();
    }

    excluirPontoBanco() {
      const pontoReferencia = this.pontosReferenciaMapService.layer.entidadePermissao.entidade;
      if (angular.isDefined(pontoReferencia.rotogramas) && pontoReferencia.rotogramas.length > 0) {
        this.openConfirmationDeleteRotogramasPonto(pontoReferencia.id);
      } else {
        this.deletePonto(pontoReferencia.id);
      }
    }

    openConfirmationDeleteRotogramasPonto(pontoId) {
      if (this.pontosReferenciaService.roleCadastrarRotograma) {
        this.deleteRotogramasAfterConfirmation(pontoId);
      } else {
        this.showErrorSnackbar('ce.mapa.common.menuExcluirPonto.erroRotograma');
        this.pontosReferenciaMapService.setLayerDefault();
      }
    }

    deleteRotogramasAfterConfirmation(pontoId) {
      /* eslint-disable */
      const container = document.querySelector('#container-delete-confirm'),
        dialog = document.createElement('vfwc-element-delete-confirm-dialog');
      /* eslint-enable */
      container.innerHTML = '';
      dialog.title = 'ce.mapa.common.menuExcluirPonto.deleteComRotogramaTitle';
      dialog.content = ['ce.mapa.common.menuExcluirPonto.deleteRotogramaConfirm'];
      dialog.cancelText = 'dialog.common.cancelar';
      dialog.confirmText = 'ce.mapa.common.modal.excluirCategoriaPonto.tituloBtExcluir';
      container.appendChild(dialog);
      dialog.addEventListener('isConfirmed', e => {
        if (e.detail && e.detail.isConfirmed) {
          this.deletePontoAndAllRotogramas(pontoId);
        } else {
          this.pontosReferenciaMapService.setLayerDefault();
        }
      });
    }

    deletePontoAndAllRotogramas(pontoId) {
      this.cadastroRotogramaService.deleteAllByPontoId(pontoId)
      .then(() => {
        this.deletePonto(pontoId);
      })
      .catch(() => {
        this.showErrorSnackbar('ce.mapa.common.modal.cadastroRotograma.errorExcluir');
        this.pontosReferenciaMapService.setLayerDefault();
      });
    }

    showErrorSnackbar(messageI18n) {
      this.alertMessage.create({
        type: 'error',
        message: this.translate.instant(messageI18n),
        appendTo: '.alerta-aqui-ponto'
      });
    }

    deletePonto(pontoId) {
      this.pontosReferenciaService.deletePontoReferencia(pontoId)
      .then(() => {
        this.alertMessage.create({
          type: 'success',
          message: this.translate.instant('ce.mapa.common.menuExcluirPonto.excluirSucesso'),
          appendTo: '.alerta-aqui-ponto'
        });
        this.pontosReferenciaMapService.removePontoAndAllMarkers(pontoId);
      })
      .catch(() => {
        this.showErrorSnackbar('ce.mapa.common.menuExcluirPonto.excluirErro');
      });
      this.pontosReferenciaMenuService.setFABDefault();
    }
  }

  angular
    .module('mapControlModule')
    .controller('MenuExcluirPontoReferenciaCtrl', MenuExcluirPontoReferenciaCtrl)
    .directive('menuExcluirPontoReferenciaDirective', menuExcluirPontoReferenciaDirective);
}());
